import React, { Component, Fragment } from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { SitecoreImageField } from 'components/sitecore-fields';
import { formStyleConstants } from '../../utils/constants/form-style-constants';
import { isEmpty } from '../../utils/obj-utils';
import { formMessageConstants } from '../../utils/constants/form-message-constants';

class FormMastercardField extends Component {
    constructor(props) {
        super(props);
        const { validState, defaultValue } = this.props;

        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCallback = this.handleChangeCallback.bind(this);
        this.handleFieldIsFilled = this.handleFieldIsFilled.bind(this);

        this.initialState = {
            defaultValue: defaultValue || formMessageConstants.emptyString,
            isFilled: !isEmpty(defaultValue),
            isValid: true,
            errorMessage: ''
        };
        if (validState) {
            this.initialState.isValid = validState.isValid;
            this.initialState.errorMessage = validState.errorMessage;
        }
        this.state = this.initialState;
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.defaultValue === nextProps.defaultValue) {
            return;
        }

        this.setState((state) => ({
            ...state,
            defaultValue: nextProps.defaultValue || formMessageConstants.emptyString,
            isFilled: !isEmpty(nextProps.defaultValue)
        }));
    }

    handleChange(event) {
        const { value } = event.target;
        const { onChange } = this.props;
        onChange(event);
        this.setState(
            (prevState) => ({
                ...prevState,
                defaultValue: value
            })
        );
    }

    handleChangeCallback() {
        const { onChange } = this.props;
        onChange(this.state);
    }

    handleBlur(event) {
        const { onBlur } = this.props;
        const { value } = event.target;
        this.handleFieldIsFilled(value);
        if (onBlur) {
            onBlur(event);
        }
    }

    handleFieldIsFilled(value) {
        const isFilled = value !== '';
        this.setState((state) => ({ ...state, isFilled }));
    }

    render() {
        const {
            name,
            autocompleteValue,
            label,
            isHidden,
            headerTitle,
            headerText,
            size,
            validState,
            formRef,
            isDisabled,
            tooltipText,
            mastercardLogo
        } = this.props;

        const { isValid, errorMessage } = validState || this.state;
        const { defaultValue, isFilled } = this.state;
        const fieldClassName = name || formStyleConstants.customFieldClassName;

        return (
            <Fragment>
                <div className="mastercard-field">
                    {!isHidden ?
                        <div className="background">
                            <div>
                                <div className='title-header'>
                                    <h4 className='title'>
                                        {headerTitle}
                                    </h4>
                                    { mastercardLogo &&
                                        <div className='mc-logo'>
                                            <SitecoreImageField img={mastercardLogo} className='mastercard-branding-light--logo' />
                                        </div>
                                    }
                                </div>
                                <div className="tab-content">
                                    <span>
                                        <div className='mastercard-field-description'>
                                            {
                                                !isEmpty(headerText) ? <div dangerouslySetInnerHTML={{ __html: headerText }}></div> :
                                                    null
                                            }
                                        </div>
                                        <div
                                            ref={formRef}
                                            className={`form-field auto-mt-xs ${fieldClassName.toLowerCase()}-field ${size || formMessageConstants.emptyString} ${isFilled ? formStyleConstants.isFilled : ''} ${!isValid ? formStyleConstants.isInvalid : ''}`}
                                            data-dc-component='form-field'
                                            data-form-control
                                            style={{ display: isHidden ? 'none' : 'block' }}
                                        >
                                            {
                                                !isEmpty(tooltipText) ? <div className='tooltip-icon-abs'><div data-tip={tooltipText} data-for='disabledTooltip' data-place='left'><FontAwesomeIcon icon={faInfoCircle} /></div>
                                                    <ReactTooltip id="disabledTooltip" /></div> : null
                                            }
                                            <input
                                                className='form-field__input'
                                                type='text'
                                                autoComplete={autocompleteValue}
                                                id={name}
                                                name={name}
                                                onChange={this.handleChange}
                                                onBlur={this.handleBlur}
                                                value={defaultValue}
                                                disabled={isDisabled}
                                            />
                                            <label className='form-field__label' htmlFor={name}>
                                                {label}
                                            </label>

                                            {!isValid ? <ul className="form-field__error-list filled">
                                                <li className="form-field__error-item">{errorMessage}</li>
                                            </ul> : null}
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div> :
                        null}
                </div>
            </Fragment>
        );
    }
}

FormMastercardField.propTypes = {
    formRef: PropTypes.object,
    name: PropTypes.string.isRequired,
    autocompleteValue: PropTypes.string,
    label: PropTypes.string.isRequired,
    headerTitle: PropTypes.string,
    headerText: PropTypes.string,
    size: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    validState: PropTypes.object,
    isDisabled: PropTypes.bool,
    tooltipText: PropTypes.string,
    mastercardLogo: PropTypes.object
};

export default FormMastercardField;
